import { render, staticRenderFns } from "./PcAdvisorLayout.vue?vue&type=template&id=664a3664"
import script from "./PcAdvisorLayout.vue?vue&type=script&lang=js"
export * from "./PcAdvisorLayout.vue?vue&type=script&lang=js"
import style0 from "./PcAdvisorLayout.vue?vue&type=style&index=0&id=664a3664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
